import React from 'react';
import { Section } from './ui/Section';
export function Authority() {
  return <Section data-id="element-62">
      <div className="bg-gradient-card border-2 border-brand-gold/40 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-63">
        <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-brand-gold" data-id="element-64">
          📚 METODOLOGÍA INDEPENDIENTE Y PROFESIONAL
        </h3>
        <p className="text-brand-text text-center mb-4 leading-relaxed" data-id="element-65">
          A diferencia de otros cursos, este manual no vende la imagen de un
          'bailarín famoso'. Es una producción editorial creada por expertos en
          pedagogía de baile y directores de academia en España.
        </p>
        <p className="text-brand-subtitle text-center font-semibold" data-id="element-66">
          Nuestro objetivo es que TÚ seas la estrella de tu clase, dándote las
          herramientas justas.
        </p>
      </div>
    </Section>;
}